import { render, staticRenderFns } from "./ImageSlotControls.vue?vue&type=template&id=53d0aad6&scoped=true&"
import script from "./ImageSlotControls.vue?vue&type=script&lang=ts&"
export * from "./ImageSlotControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0aad6",
  null
  
)

export default component.exports